namespace $ {

	export class $shm_hitalama_map_history_storage_target_writers extends $giper_baza_dict_to(
		$shm_hitalama_map_history_storage_target_writer,
	) {

		ready() { return $shm_hitalama_map_history_storage_ready.settled(this) }

		Registry_routed( auto?: any ) {
			return this.dive( 'history-writer-registry:Registry_routed', $giper_baza_atom_bool, auto )
		}

		registry() {
			return this.land().area_make( $mol_hash_string( `${this.link().str}:history-writer-registry` ) )
				.Data( $shm_hitalama_map_history_storage_target_writers_shard )
		}

		@ $mol_mem
		override keys(): readonly $giper_baza_vary_type[] {
			const keys = super.keys().filter( key=> key !== 'history-writer-registry:Registry_routed' )
			if( !this.Registry_routed()?.val() ) return keys
			return [...new Set([ ...keys, ...this.registry().members() ])]
		}

		override key( key: $giper_baza_vary_type, auto?: any ) {
			this.ready()
			let embedded = super.key( key )
			if( !embedded && auto !== undefined && (typeof key !== 'string'
				|| $mol_charset_encode(key).byteLength > 512) ) {
				throw new Error( 'Некорректный идентификатор автора истории' )
			}
			if( !embedded && typeof key === 'string' ) {
				const raw = super.keys().filter( key=> key !== 'history-writer-registry:Registry_routed' )
				if( this.Registry_routed()?.val() || (auto !== undefined
					&& raw.length >= $shm_hitalama_map_history_storage_target_writers_shard.capacity) ) {
					if( auto !== undefined ) this.Registry_routed(null)!.val( true )
					if( !this.registry().contains( key, auto !== undefined ) ) return null as any
					const namespace = key.startsWith('session:') ? 'history-session' : 'history-sharded-writer'
					return this.land().area_make( $mol_hash_string( `${this.link().str}:${namespace}:${key}` ) )
						.Data( $shm_hitalama_map_history_storage_target_writer )
				}
			}
			if( !embedded && auto !== undefined ) embedded = super.key( key, auto )
			if( !embedded || typeof key !== 'string' || !key.startsWith( 'session:' ) ) return embedded
			// The registry keeps only the writer key. Mutable counters and heads
			// belong to separate physical-writer areas, not the shared target land.
			return this.land().area_make( $mol_hash_string( `${ this.link().str }:history-session:${ key }` ) )
				.Data( $shm_hitalama_map_history_storage_target_writer )
		}
	}

}
